// extracted by mini-css-extract-plugin
module.exports = {"open-hours":"Content_open-hours__gMcX6"};